export const UPLOAD_FILE_MULTIPART_LOADING = "UPLOAD_FILE_MULTIPART_LOADING";
export const UPLOAD_FILE_MULTIPART_SUCCESS = "UPLOAD_FILE_MULTIPART_SUCCESS";
export const UPLOAD_FILE_MULTIPART_FAILED = "UPLOAD_FILE_MULTIPART_FAILED";


export const REMOVE_FILE_LOADING = "REMOVE_FILE_LOADING";
export const REMOVE_FILE_SUCCESS = "REMOVE_FILESUCCESS";
export const REMOVE_FILE_FAILED = "REMOVE_FILE_FAILED";
